import React from "react";
import styles from "./List.module.scss";
import { cx } from "../../../helpers/ClassNames.helper";
import { t } from "../../../helpers/translate.helper";

const List = ({ label, icon, entries, selectedIndex, handleSelect }) => (
	<div className={styles.host}>
		{label && <label>{icon && <i className={"fas fa-" + icon}></i>}{label}</label>}
		<div className={styles.listWrapper}>
			<div className={cx(styles.list, handleSelect && styles.selectable)}>
				{
					entries && entries.map(
						(entry, index) => (
							<div
								className={cx(styles.entry, selectedIndex === index && styles.selected)}
								key={(entry.title || entry.title_translate) + index}
								onClick={handleSelect && (() => handleSelect(entry, index))}>
								{entry.title || (entry.title_translate && t(entry.title_translate))}
							</div>
						))
				}
			</div>
		</div>
	</div>
);

export default List;
